"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var isValidDOMElement = exports.isValidDOMElement = function isValidDOMElement(node) {
  //if a user is hidden by css or otherwise, the offset parent will be null https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/offsetParent 
  if (!node.offsetParent) {
    return false;
  }

  return true;
};